import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Dashboardheader from "../directives/dashboardheader";
import { Col, Container, Row } from "react-bootstrap";
import { getTransferHistoryDataAction } from "../Action/user.action";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";

const CreditTransferHistory = () => {
  const [transferHistory, setTransferHistory] = useState([]);
  const [paginationStatus, setPaginationStatus] = useState(false);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    getTransferHistory();
  }, [page]);

  const getTransferHistory = async () => {
    const body = { page, limit: 10 };
    let res = await getTransferHistoryDataAction(body);

    if (res?.data?.history?.length === 0) {
      setPaginationStatus(true);
      return;
    }

    if (res.success) {
      setTransferHistory((prev) => [...prev, ...res.data.history]);
    }
  };

  const copieBtn = async () => {
    toast.success(`Copied!`);
  };

  const handleLoadMore = () => setPage(page + 1);
  const handleBackNavigation = () => {
    navigate(-1);
  };
  return (
    <>
      <Dashboardheader />
      <Toaster />
      <Container>
        <Row className="my-4">
          <h4 style={{ color: "white" }}>Credit Transfer History </h4>
          <p
            className="position-relative"
            style={{
              color: "white",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
            onClick={handleBackNavigation}
          >
            <IoIosArrowRoundBack size={35} />
          </p>

          {transferHistory.length > 0 ? (
            <>
              {transferHistory.map((item, index) => {
                // -------- CONDITIONS ----------
                const isCredit = item.typeid === 0;
                const displayAmount = isCredit
                  ? `${item.amount}`
                  : `${item.amount}`;

                const amountColor = isCredit ? "#00ff6a" : "#ff4b4b";

                return (
                  <Col xl={12} key={index} className="mb-4">
                    <div
                      style={{
                        backgroundColor: "#151515",
                        borderRadius: 10,
                        color: "white",
                      }}
                    >
                      {/* HEADER */}
                      <div
                        style={{
                          background: "#0d1a2b",
                          padding: "10px 15px",
                          borderRadius: "10px 10px 0 0",
                          fontSize: 16,
                        }}
                      >
                        Type: {item.trx_type}
                      </div>

                      <Row className="py-3 gy-3 px-3">
                        {/* DATE/TIME */}
                        <Col
                          lg={3}
                          md={3}
                          sm={3}
                          xs={3}
                          className="text-center"
                        >
                          <p className="text-secondary mb-1">Date</p>
                          <p className="fw-bold">{item.trx_date}</p>
                        </Col>

                        <Col
                          lg={3}
                          md={3}
                          sm={3}
                          xs={3}
                          className="text-center"
                        >
                          <p className="text-secondary mb-1">Time</p>
                          <p className="fw-bold">{item.trx_time}</p>
                        </Col>

                        {/* SENDER */}
                        <Col lg={3} md={3} sm={3} xs={3}>
                          <p className="text-secondary mb-1">
                            {item.typeid === 0 ? "Wallet Address" : "Hash"}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <p
                              className="fw-bold mb-0"
                              style={{ wordBreak: "break-all" }}
                            >
                              {item.sender}
                            </p>

                            <CopyToClipboard text={item.sender_wallet}>
                              <span
                                title="Click to Copy"
                                className="mr-copylink"
                                onClick={copieBtn}
                                style={{
                                  cursor: "pointer",
                                  color: "rgb(157 81 255)",
                                  fontSize: 18,
                                }}
                              >
                                <i className="fa fa-clone"></i>
                              </span>
                            </CopyToClipboard>
                          </div>
                        </Col>

                        {/* AMOUNT */}
                        <Col lg={3} md={3} sm={3} xs={3} className="text-end">
                          <p className="text-secondary mb-1">Amount</p>
                          <p
                            className="fw-bold"
                            style={{ color: amountColor, fontSize: 17 }}
                          >
                            {displayAmount} ANANT
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                );
              })}
            </>
          ) : (
            <div
              className="text-center d-flex flex-column justify-content-center align-items-center"
              style={{ height: "80vh", color: "#d3d3d3" }}
            >
              <img
                src="assets/images/newdesign/nodata-new.png"
                style={{ width: 220, opacity: 0.8 }}
              />
              <h4>No data found</h4>
            </div>
          )}

          {/* LOAD MORE */}
          {transferHistory.length >= 10 && !paginationStatus && (
            <center onClick={handleLoadMore}>
              <div
                style={{
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "black",
                  width: 180,
                  borderRadius: 8,
                  padding: "10px 0",
                  marginTop: 10,
                }}
              >
                Load More
              </div>
            </center>
          )}
        </Row>
      </Container>
    </>
  );
};

export default CreditTransferHistory;
